class SessionService {
  sessionCallback?: () => void;

  observe(callback: () => void) {
    this.sessionCallback = callback;
  }

  unAuthenticated() {
    this.sessionCallback?.();
  }

  clear() {
    this.sessionCallback = undefined;
  }
}

const sessionService = new SessionService();

export default sessionService;